import { Injectable } from '@angular/core';
import { Actions, createEffect } from '@ngrx/effects';
import { DataPersistence } from '@nrwl/angular';
import { ApiService } from '@quorum/api';
import * as fromDeclinedReasons from './declined-reasons.actions';
import { DeclinedReasonsState } from './declined-reasons.interfaces';
import { map } from 'rxjs/operators';
import { DeclinedReason } from '@quorum/models/xs-resource';
@Injectable()
export class DeclinedReasonsEffects {
  
  getDeclinedReasonsFromServer = createEffect(() => this.dataPersistence.fetch(fromDeclinedReasons.GET_DECLINED_REASONS_FROM_SERVER, {
    run: (action: fromDeclinedReasons.GetDeclinedReasonsFromServer, state: any) => {
      if (state.svcDropdowns.declinedReasons.ids.length == 0) {
        return this.apiService
          .get<DeclinedReason[]>(`v/1/fixed-operations/declined-reasons`, {
            params: action.payload
          })
          .pipe(
            map((declinedReasons: DeclinedReason[]) => {
              return new fromDeclinedReasons.GetDeclinedReasonsFromServerSuccess({
                declinedReasons: declinedReasons
              });
            })
          );
      }
    },
    onError: (action: fromDeclinedReasons.GetDeclinedReasonsFromServer, error) => {
      console.error('Error', error);
    }
  }));

  constructor(
    private actions: Actions,
    private dataPersistence: DataPersistence<DeclinedReasonsState>,
    private apiService: ApiService
  ) {}
}
